export enum SortOptions {
    Latest = 'latest',
    Oldest = 'oldest',
    LowRated = 'lowest',
    HighRated = 'highest'
}

export enum MentionFilters {
    FullTime = 'full-time',
    Hygiene = 'hygiene',
    OneTwoOne = '1-2-1-Tutoring'
}

export enum StudyLevelFilters {
    Undergraduate = 'undergraduate',
    Postgraduate = 'postgraduate'
}

export enum CategoryFilters {
    Overall = 'overall',
    University = 'university',
    Course = 'course',
    UniHalls = 'uni-halls'
}

export enum ReviewFilterQueryParamKeys {
    Rating = 'rating',
    Keyword = 'keyword',
    StudyLevel = 'studyLevel',
    Subjects = 'subjects',
    Category = 'category',
    PageNo = 'pageno',
    SortBy = 'sortBy'
}

export const MENTION_FILTERS = [
    {
        label: 'Full time',
        value: MentionFilters.FullTime
    },
    {
        label: 'Hygiene',
        value: MentionFilters.Hygiene
    },
    {
        label: '1-2-1 Tutoring',
        value: MentionFilters.OneTwoOne
    }
];

export const STUDY_LEVEL_FILTERS = [
    {
        label: 'Undergraduate',
        value: StudyLevelFilters.Undergraduate
    },
    {
        label: 'Postgraduate',
        value: StudyLevelFilters.Postgraduate
    }
];

export const CATEGORY_FILTERS = [
    {
        label: 'Overall',
        value: CategoryFilters.Overall
    },
    {
        label: 'University',
        value: CategoryFilters.University
    },
    {
        label: 'Course',
        value: CategoryFilters.Course
    },
    {
        label: 'Uni halls',
        value: CategoryFilters.UniHalls
    }
];

export const defaultPageNo = 1;
export const defaultSortBy = SortOptions.Latest;
export const REVIEWS_PER_PAGE = 20;
export const defaultReviewFilters = {
    studyLevel: 'undergraduate',
    studyMode: '',
    category: '',
    rating: ''
}